import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireWeaverAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.weavers <= 0) return false;
    if (!unassignJob(settlement, 'weavers')) return false;
    settlement.production.weaver.progress.pop();
    return true;
};
